import { type GlobalSearchStateMessage } from '../../data-access/types/GlobalSearchResponse'
import { type GlobalSearchResultTypeEnum } from '../enums'
import {
  GlobalSearchResultItem,
  type GlobalSearchResultItemConstructor,
} from '../GlobalSearchResultItem'

export interface GlobalSearchResultConstructor {
  items: GlobalSearchResultItemConstructor[]
  counts: Map<GlobalSearchResultTypeEnum, number>
  total: number
  isTruncated: boolean
  isUnsupportedQuery: boolean
  noResultsMessage: Nullable<GlobalSearchStateMessage>
  unsupportedQueryMessage: Nullable<GlobalSearchStateMessage>
  conversationId: Nullable<string>
}

export class GlobalSearchResult {
  readonly items: GlobalSearchResultItem[]
  readonly counts: Map<GlobalSearchResultTypeEnum, number>
  readonly total: number
  readonly isTruncated: boolean
  readonly isUnsupportedQuery: boolean
  readonly noResultsMessage: Nullable<GlobalSearchStateMessage>
  readonly unsupportedQueryMessage: Nullable<GlobalSearchStateMessage>
  readonly conversationId: Nullable<string>

  constructor(data: GlobalSearchResultConstructor) {
    this.items = data.items.map((item) => new GlobalSearchResultItem(item))
    this.counts = data.counts
    this.total = data.total
    this.isTruncated = data.isTruncated
    this.isUnsupportedQuery = data.isUnsupportedQuery
    this.noResultsMessage = data.noResultsMessage
    this.unsupportedQueryMessage = data.unsupportedQueryMessage
    this.conversationId = data.conversationId
  }
}
